import setup from './moduleSetup';

export default {
    name: 'purchaseOrders',
    before: [],
    after: [],
    setup,
};
